import { ApiService } from '../apiService'
import { getSiteTaskGroups } from './siteTaskGroupService'

export const DEFAULT_MIN_DATE_ISO = new Date()
const findMinDate = (site_tasks) => site_tasks.map(site_task => site_task.start_date).filter(e => e).sort().at(0)
const findMaxDate = (site_tasks) => site_tasks.map(site_task => site_task.end_date).filter(e => e).sort().at(-1)
const addMonthsToDate = (dateString, months) => {
  if (!dateString) return null
  const date = new Date(dateString)
  date.setMonth(date.getMonth() + months)
  return date.toISOString()
}

const getProjects = ({ with_active_sites }) => {
  const query = with_active_sites ? '?with_active_sites=true' : ''
  return ApiService.get(`/projects.json${query}`).then(({ projects }) => projects)
}

const getSiteCategories = (organizationId) =>
  ApiService.get(`/organizations/${organizationId}/task_categories.json?with_discarded=true`)
    .then(({ task_categories }) => task_categories)

const getCalendarTasks = (projectId = null) => {
  const path = projectId ? `/projects/${projectId}/calendar_tasks.json` : '/calendar_tasks'
  return ApiService.get(path).then(({ data }) => data)
}

export const getCalendarData = async (organizationId, projectId = null, defaultDate = DEFAULT_MIN_DATE_ISO) => {
  const projects = await getProjects({ with_active_sites: true })
  const taskCategories = await getSiteCategories(organizationId)
  const calendarTasks = await getCalendarTasks(projectId)
  const siteTaskGroups = await getSiteTaskGroups(projectId)
  const minDate = findMinDate(calendarTasks) || defaultDate

  return {
    settings: {
      minDate: new Date(minDate),
      maxDate: new Date(findMaxDate(calendarTasks) || addMonthsToDate(minDate, 3)),
    },
    projects,
    taskCategories,
    calendarTasks,
    siteTaskGroups,
  }
}

